import BaseTracker from './base-tracker';

export default class CollapseTracker extends BaseTracker {
  start() {
    this._player.addEventListener('fullscreen', this._onFullscreen);
  }

  _onFullscreen = ({ detail: { isFullscreen } }) => {
    if (!isFullscreen) {
      this.track();
    }
  };

  stop() {
    this._player.removeEventListener('fullscreen', this._onFullscreen);
  }
}
